export class AnalyticsPageModel {
    documentType = '';
    documentName = '';
    documentNumber = '';
    documentIssuing = '';
    documentExpeditionState = '';
    documentExpeditionDate = '';
    email = '';
    phoneNumber = '';
    motherName = '';
    birthDate = '';
    birthCountry = '';
    birthState = '';
    birthCity = '';
    nationality = '';
    gender = '';
    profession = '';
    originIncome = '';
    pep = '';
    infoData = '';
    companyInformation = '';
    cep = '';
    addressName = '';
    addressNumber = '';
    addressAdjunct = '';
    addressDistrict = '';
    addressCity = '';
    addressState = '';
    addressComplete = '';
    errorAPI = '';
    maritalStatus = '';
    spouse = '';
    income = '';
    patrimony = '';
    taxResidency = '';
    taxResidencyCountry = '';
    nif = '';
    dateTaxResidency = '';
    action = '';
    back = '';
    terms = '';
    broker = '';
    relatedPerson = '';
    checkData = '';
    name = '';
    dataAnalysisStatus = '';
    dataAnalysisStatusEvent = '';
    dataAnalysisStatusLabel = '';
    data = '';
    brokerRegistration = '';
    check = '';
    completeLater = '';
    completeRegistration = '';
    close = '';
    actionClose = '';
    knowMore = '';
    enterData = '';
    continueNewUser = '';
    continue = '';
}
